import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeGate from "../pages/Home/HomeGate";
import AdminRoutes from "./AdminRoutes";
import SeniorCoordinator from "./SeniorCoordinatorRoutes";
import StudentRoutes from "./StudentRoutes";
import ScholarshipForm from "../pages/ScholarshipForm/ScholarshipForm";
import StepperForm from "../pages/ScholarshipForm/StepperForm";
import Application from "../pages/AdminDashboard/Application";
import StudentDetail from "../pages/AdminDashboard/AdminDashboard";
import ReviewerRoutes from "./ReviewerRoutes";
import ApproverRoutes from "./ApproverRoutes";
import VendorRoutes from "./VendorRoutes";
import RecordKeeperRoutes from "./RecordKeeperRoutes";
import FinanceRoutes from "./FinanceRoutes";
import ForgotPassword from "../pages/Home/Forgotpassword";
import ResetPassword from "../pages/Home/ResetPassword";
import AccountDeletion from "../pages/Home/AccountDeletion";
import RoleProtectedRoute from "./RoleProtectedRoute";

const AppRouterWrapper = () => (
  <Routes>
    <Route path="/" element={<HomeGate />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password/:token" element={<ResetPassword />} />
    <Route path="/scholarshipForm/:token" element={<ScholarshipForm />} />
    <Route path="/stepperForm" element={<StepperForm />} />
    <Route path="/account-deletion" element={<AccountDeletion />} />
    <Route path="/dashboard/*" element={<RoleProtectedRoute role="superAdmin" element={<AdminRoutes />} />} />
    <Route path="/student/*" element={<RoleProtectedRoute role="student" element={<StudentRoutes />} />} />
    <Route path="/reviewer/*" element={<RoleProtectedRoute role="reviewer" element={<ReviewerRoutes />} />} />
    <Route path="/approver/*" element={<RoleProtectedRoute role="approver" element={<ApproverRoutes />} />} />
    <Route path="/partner/*" element={<RoleProtectedRoute role="vendor" element={<VendorRoutes />} />} />
    <Route path="/record-keeper/*" element={<RoleProtectedRoute role="record-keeper" element={<RecordKeeperRoutes />} />} />
    <Route path="/finance/*" element={<RoleProtectedRoute role="finance" element={<FinanceRoutes />} />} />
    <Route path="/admin/*" element={<RoleProtectedRoute role="al-kauser Admin" element={<SeniorCoordinator />} />} />
    <Route path="/adminDashboard/:CNICNo" element={<StudentDetail />} />
    <Route path="/adminApplication" element={<Application />} />
  </Routes>
);

const AppRouter = () => (
  <BrowserRouter>
    <AppRouterWrapper />
  </BrowserRouter>
);

export default AppRouter;
